"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 4c1.44 0 2.79.38 3.95 1.05L17.4 3.6C15.85 2.59 13.99 2 12 2s-3.85.59-5.41 1.59l1.45 1.45C9.21 4.38 10.56 4 12 4m8 8c0 1.44-.38 2.79-1.05 3.95l1.45 1.45c1.01-1.55 1.6-3.41 1.6-5.4s-.59-3.85-1.59-5.41l-1.45 1.45C19.62 9.21 20 10.56 20 12m-8 8c-1.44 0-2.79-.38-3.95-1.05L6.6 20.4C8.15 21.41 10.01 22 12 22s3.85-.59 5.41-1.59l-1.45-1.45C14.79 19.62 13.44 20 12 20m-8-8c0-1.44.38-2.79 1.05-3.95L3.59 6.59C2.59 8.15 2 10.01 2 12s.59 3.85 1.59 5.41l1.45-1.45C4.38 14.79 4 13.44 4 12m7.5-6C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82C10.56 17.17 11.71 18 13 18c1.65 0 3-1.35 3-3h-2c0 .55-.45 1-1 1-.43 0-.81-.27-.95-.68-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5 9 9.12 10.12 8 11.5 8c1.21 0 2.22.86 2.45 2h2.02c-.25-2.25-2.16-4-4.47-4"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "13.5",
  cy: "12.5",
  r: "1.5"
}, "1")], 'NoiseControlOffTwoTone');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/icons-material/esm/NoiseControlOffTwoTone.js
// module id = 8610
// module chunks = 0